export abstract class TokenGateway {
  abstract clearStorage(): void;
  abstract saveToken(token: any): void;
  abstract getToken(): any;
  abstract saveUser(user: any): void;
  abstract getUser(): any;
}
